import imigrationReport from './imigrationReport';
import reservationReport from './reservationReport';

export default [
    ...imigrationReport,
    ...reservationReport
]